export default __webpack_public_path__ + "static/media/torre-attack.32dad60a.webp";